import io from 'socket.io-client';
import _ from 'lodash';
import {
  SOCKET,
  SOCKET_LOG_INFO,
  SUCCESS,
} from 'flaivy-react/reducers/action-type';
import { ACTION_TYPES as AUTH_ACTION_TYPES } from '../reducers/auth.reducer';

import { getAxiosInstanceWithoutErrorChecking } from '../../config/api';

import pluralize from 'pluralize';

export const hasIdInStore = (state, entityId) => {
  for (const reducer in state) {
    if (Object.hasOwnProperty.call(state, reducer)) {
      const storeData = state[reducer];
      if (storeData && storeData.id === entityId) {
        return true;
      }
      if (_.isObject(storeData)) {
        const recursiveCheck = hasIdInStore(storeData, entityId);
        if (recursiveCheck) {
          return true;
        }
      }
    }
  }
  return false;
};

export default function socketMiddleware() {
  let socket = null;
  function attach(dispatch, loggedInUser, store) {
    socket = io({
      transports: ['websocket'],
    });

    // Event queue and processing flag
    const eventQueue = [];
    let processing = false;

    const processQueue = async () => {
      if (processing) return;
      processing = true;
      while (eventQueue.length > 0) {
        const event = eventQueue.shift();
        await handleEvent(event);
      }
      processing = false;
    };

    const handleEvent = async event => {
      const eventName = event.eventName;
      const state = store.getState();

      if (!event.entityId) {
        return;
      }
      const isUpdateEvent = !_.endsWith(eventName, '_CREATED');
      if (isUpdateEvent && !hasIdInStore(state, event.entityId)) {
        return;
      }

      try {
        const instance = getAxiosInstanceWithoutErrorChecking();
        const result = await instance.get(
          `${pluralize.plural(event.entityModel)}/${event.entityId}`,
        );
        dispatch({
          type: SOCKET(eventName),
          payload: {
            eventName,
            fullEntity: result.data,
            loggedInUser,
            userId: event.userId,
          },
        });
      } catch (e) {
        dispatch({
          type: SOCKET_LOG_INFO(eventName),
          payload: { eventName, loggedInUser, userId: event.userId },
        });
        console.log('error', e);
      }
    };

    socket.on(loggedInUser.organization.id, event => {
      eventQueue.push(event);
      processQueue();
    });
  }

  function detach() {
    socket.disconnect();
  }

  return store => next => {
    const { authentication } = store.getState();

    if (authentication.isAuthenticated) {
      attach(store.dispatch, authentication.sessionUser, store);
    }
    return action => {
      switch (action.type) {
        case SUCCESS(AUTH_ACTION_TYPES.LOGIN):
          attach(store.dispatch, action.payload.data, store);
          break;
        case AUTH_ACTION_TYPES.LOGOUT:
          detach(authentication.sessionUser);
          break;
        default:
      }
      return next(action);
    };
  };
}
